import { Link } from "react-router-dom";
import { AppstoreAddOutlined, CheckOutlined, CloseOutlined, UserAddOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Tabs, Space, message } from "antd";
import { useRef, useState } from "react";
import { CreateNotificationModal } from "../components/CreateNotificationModal";
import DataTable from "../components/DataTable";
import { hostname, ISO8601 } from "../hooks/useEndeavour";
import Status from "../components/Status";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import UserBindingNotificationsDrawer from "../components/UserBindingNotificationsDrawer";

function AppNotificationsPage() {
  const createNotificationRef = useRef();
  const [tagForceUpdate, setTagForceUpdate] = useState(0);
  const [templateForceUpdate, setTemplateForceUpdate] = useState(0);
  const userBindNotificationRef = useRef();
  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/user/tag`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status != 200) {
            message.error("Update Fail");
          }
          setTagForceUpdate(tagForceUpdate + 1);
          message.success("Update Success");
        });
    },
  });

  const enableTag = (email, tag) => {
    submit.mutate({
      users: [email],
      tag: [tag],
      action: "create",
    });
  };
  const disableTag = (email, tag) => {
    submit.mutate({
      users: [email],
      tag: [tag],
      action: "delete",
    });
  };
  const forceUpdate = () => {
    setTemplateForceUpdate(templateForceUpdate + 1);
  };
  const drawerOnClick = (data) => {
    userBindNotificationRef.current.openDrawer(data);
  };

  return (
    <Tabs
      items={[
        {
          key: "template-management",
          label: "Template Management",
          children: (
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <UserBindingNotificationsDrawer ref={userBindNotificationRef} />
                <CreateNotificationModal ref={createNotificationRef} onChange={forceUpdate} />
                <DataTable
                  ForceUpdate={templateForceUpdate}
                  uri={`${hostname}/pa-alliance/notification/template`}
                  tableTitle={
                    <Button
                      type="primary"
                      icon={<AppstoreAddOutlined />}
                      style={{ marginBottom: 10 }}
                      onClick={() => createNotificationRef.current.showModal()}
                    >
                      Add Template
                    </Button>
                  }
                  filters={[
                    <Form.Item name={"body"} label="Body">
                      <Input allowClear placeholder="Search by content" autoFocus />
                    </Form.Item>,
                    <Form.Item name={"channel"} label="Channel">
                      <Input allowClear placeholder="Search by channel" />
                    </Form.Item>,
                    <Form.Item name={"status"} label="Status" key="type">
                      <Select>
                        <Select.Option value="create">Create</Select.Option>
                        <Select.Option value="approved">Approved</Select.Option>
                        <Select.Option value="rejected">Rejected</Select.Option>
                      </Select>
                    </Form.Item>,
                    <Form.Item name={"type"} label="Type" key="type">
                      <Select>
                        <Select.Option value="email">Email</Select.Option>
                        <Select.Option value="sms">SMS</Select.Option>
                        <Select.Option value="push">Push Notification</Select.Option>
                      </Select>
                    </Form.Item>,
                  ]}
                  tableColumns={[
                    {
                      title: "Type",
                      render: (item) => {
                        return <Link to={`/notification/${item.id}`}>{item.type}</Link>;
                      },
                    },
                    {
                      title: "Title",
                      render: (item) => {
                        return item.title;
                      },
                    },
                    {
                      title: "Content",
                      render: (item) => {
                        return item.body;
                      },
                    },

                    // {
                    //   title: "Action",
                    //   render: (item) => {
                    //     return (
                    //       <Space>
                    //         <Button icon={<UserAddOutlined />} type="primary" onClick={() => drawerOnClick(item)}>
                    //           Binding Users
                    //         </Button>
                    //         <Button icon={<UserAddOutlined />} type="primary" onClick={() => drawerOnClick(item)}>
                    //           Approve
                    //         </Button>
                    //       </Space>
                    //     );
                    //   },
                    // },
                  ]}
                />
              </Col>
            </Row>
          ),
        },
        {
          key: "tag-management",
          label: "User Tag Management",
          children: (
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <DataTable
                  ForceUpdate={tagForceUpdate}
                  uri={`${hostname}/pa-alliance/notification/user/tag`}
                  filters={[
                    <Form.Item name={"user_email"} label="Email">
                      <Input allowClear placeholder="Search by email" />
                    </Form.Item>,
                    <Form.Item name={"tag"} label="Tag">
                      <Input allowClear placeholder="Search by tag" />
                    </Form.Item>,
                    <Form.Item name={"status"} label="Status" key="status">
                      <Select>
                        <Select.Option value="enable">Enable</Select.Option>
                        <Select.Option value="disable">Disable</Select.Option>
                      </Select>
                    </Form.Item>,
                  ]}
                  tableColumns={[
                    {
                      title: "Email",
                      render: (item) => {
                        return item.user_email;
                      },
                    },
                    {
                      title: "Tag",
                      render: (item) => {
                        return item.tag;
                      },
                    },
                    {
                      title: "Status",
                      align: "center",
                      render: (item) => {
                        return <Status value={item.status} />;
                      },
                    },

                    {
                      title: "Action",
                      align: "center",
                      render: (item) => {
                        switch (item.status) {
                          case "enable":
                            return (
                              <Button icon={<CloseOutlined />} color="danger" variant="solid" onClick={() => disableTag(item.user_email, item.tag)}>
                                Disable
                              </Button>
                            );
                          case "disable":
                            return (
                              <Button icon={<CheckOutlined />} type="primary" onClick={() => enableTag(item.user_email, item.tag)}>
                                Enable
                              </Button>
                            );
                        }
                      },
                    },
                  ]}
                />
              </Col>
            </Row>
          ),
        },
      ]}
    />
  );
}

export default AppNotificationsPage;
